var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.782,
    height: 18,
    viewBox: "0 0 93.782 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stars",
    transform: "translate(-666.82 -376.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M290.738,284.13a1,1,0,0,0-.858-.685l-5.423-.493-2.144-5.016a1,1,0,0,0-1.836,0l-2.144,5.016-5.422.493a1,1,0,0,0-.567,1.747l4.1,3.594-1.209,5.322a1,1,0,0,0,1.485,1.079l4.676-2.795,4.674,2.795a1,1,0,0,0,1.485-1.079l-1.209-5.322,4.1-3.595a1,1,0,0,0,.292-1.06Zm0,0",
    transform: "translate(394.815 99.172)",
    fill: "#ffd200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M290.738,284.13a1,1,0,0,0-.858-.685l-5.423-.493-2.144-5.016a1,1,0,0,0-1.836,0l-2.144,5.016-5.422.493a1,1,0,0,0-.567,1.747l4.1,3.594-1.209,5.322a1,1,0,0,0,1.485,1.079l4.676-2.795,4.674,2.795a1,1,0,0,0,1.485-1.079l-1.209-5.322,4.1-3.595a1,1,0,0,0,.292-1.06Zm0,0",
    transform: "translate(419.815 99.172)",
    fill: "#ffd200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M290.738,284.13a1,1,0,0,0-.858-.685l-5.423-.493-2.144-5.016a1,1,0,0,0-1.836,0l-2.144,5.016-5.422.493a1,1,0,0,0-.567,1.747l4.1,3.594-1.209,5.322a1,1,0,0,0,1.485,1.079l4.676-2.795,4.674,2.795a1,1,0,0,0,1.485-1.079l-1.209-5.322,4.1-3.595a1,1,0,0,0,.292-1.06Zm0,0",
    transform: "translate(444.815 99.172)",
    fill: "#ffd200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M290.738,284.13a1,1,0,0,0-.858-.685l-5.423-.493-2.144-5.016a1,1,0,0,0-1.836,0l-2.144,5.016-5.422.493a1,1,0,0,0-.567,1.747l4.1,3.594-1.209,5.322a1,1,0,0,0,1.485,1.079l4.676-2.795,4.674,2.795a1,1,0,0,0,1.485-1.079l-1.209-5.322,4.1-3.595a1,1,0,0,0,.292-1.06Zm0,0",
    transform: "translate(469.815 99.172)",
    fill: "#ffd200"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.2afc9cf94f808d9f25ed6010db7baf0c.svg";
export { ForwardRef as ReactComponent };